export default __webpack_public_path__ + "static/media/logo.42670d19.png";